module.exports = __webpack_public_path__ + "static/ml_emotion-60721020e47c6678c3e2ecf8f3deed5d.png";